import { HashLink } from "react-router-hash-link";
import { GlassBtn } from "../buttons";
import { CoinsIcon } from "../icons";
import "./roleBasedButtons.scss";

const RoleBasedButtons = ({ currentMemberId }) => {
  if (!currentMemberId) return null;
  let dashboardText;
  let dashboardPath;

  switch (currentMemberId.role) {
    case "admin":
      dashboardText = "Admin Dashboard";
      dashboardPath = `/user-profile/${currentMemberId.id}/admin-dashboard#adminTop`;
      break;
    case "brandAmbassador":
      dashboardText = "Ambassador Dashboard";
      dashboardPath = `/user-profile/${currentMemberId.id}/ambassador-dashboard#ambTop`;
      break;
    case "fieldLeader":
      dashboardText = "FieldLeader Dashboard";
      dashboardPath = `/user-profile/${currentMemberId.id}/field-leader-dashboard#leaderTop`;
      break;
    // case "member": /// since i need to do background checks this will be a later flow feature
    //   dashboardText = "Become a Brand Ambassador"; // we will notify the target id in
    //   // another task it will be the admin and this is the source id
    //   break;
    default:
      // If no matching role, maybe hide the button or default to something else
      return null;
  }

  return (
    <div className="glassBtnUserProfileDiv">
      <HashLink
        to={dashboardPath}
        scroll={(el) =>
          el.scrollIntoView({ behavior: "smooth", block: "start" })
        }
      >
        <GlassBtn
          glassBtnImage={
            <CoinsIcon
              height="18px"
              width="18px"
              fillColor="var(--color-gold)"
            />
          }
          className="glass-btn"
          glassRefClassName="adminDashboardGlassBtnRef"
          glassBtnText={dashboardText}
          glassBtnWidth="250px"
          glassBtnHeight="40px"
          glassBtnTextFontSize="1rem"
          glassBtnFontWeight="700"
          glassBtnFontColor="var(--color-gold)"
          glassBtnTextDecorationColor="var(--color-gold)"
          hi2Style={{
            transform: "rotate(90deg) translate(-20px, 125px)",
          }}
          hi3Style={{
            transform: "rotate(90deg) translate(-20px, -125px)",
          }}
        />
      </HashLink>
    </div>
  );
};
export default RoleBasedButtons;
